export default (type, id, account, canPay) => `
  <div class="microaccount-account-info alert alert-orange">
    <h4 class="mb-3">Indywidualny rachunek przypisany do podatnika (tzw. mikrorachunek podatkowy)</h4>
    ${(type === 1 ? 'PESEL' : 'NIP')}: <span class="microaccount-your-id"><b>${id}</b></span></br>
    Numer mikrorachunku: <b>${account.html}</b></br>
    
    <div class="btn-bar microaccount-btns row mt-2 pt-0">
      <div class="col-md-4 mt-2">
        <button type="button" class="btn btn-outline-primary copy-element">Kopiuj numer rachunku</button>
      </div>
      <div class="col-md-4 mt-2">
        <button type="button" class="btn btn-outline-secondary fill-again">Uzupełnij ponownie</button>
      </div>
      ${(canPay ?
        `<div class="col-md-4 mt-2">
          <button type="button" class="btn more show-pay-form">Opłać podatek już teraz!</button>
        </div>` 
        : ''
      )}
    </div>
  </div>
`;
